import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import {Col, Row} from 'react-bootstrap'
import toast from 'react-hot-toast'
import {useQueries} from 'react-query'
import {createStudent} from './api'
import {fetchShiftList} from '../shift/api'
import {fetchClassList} from '../class/api'
import {fetchDivisionList} from '../division/api'
import {RunnerBall} from '../../../components/FormLoader'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'
import {handleApiError} from '../../../helpers/errorHandler'
import {fetchActiveDropTrips, fetchActivePickupTrips} from '../trip/api'
import {getCountryCallingCode, isPossiblePhoneNumber} from 'react-phone-number-input'
import {fetchSubSchoolDetails} from '../profile/api'
import CountrySelect from '../../../components/CountryDropdown'

function StudentCreationForm({onAfterSubmit}) {
  const calls = [
    {queryKey: 'shift', queryFn: fetchShiftList, refetchOnWindowFocus: false},
    {queryKey: 'class', queryFn: fetchClassList, refetchOnWindowFocus: false},
    {
      queryKey: 'division',
      queryFn: fetchDivisionList,
      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'active-pickup-trips',
      queryFn: fetchActivePickupTrips,
      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'active-drop-trips',
      queryFn: fetchActiveDropTrips,
      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'sub-school',
      queryFn: fetchSubSchoolDetails,
      refetchOnWindowFocus: false,
    },
  ]
  const results = useQueries(calls)

  if (
    results[0].isFetching ||
    results[1].isFetching ||
    results[2].isFetching ||
    results[3].isFetching ||
    results[4].isFetching ||
    results[5].isFetching
  ) {
    // return <RunnerBall />
  }

  const shiftList = results[0]?.data?.data
  const gradeList = results[1]?.data?.data
  const divisionList = results[2]?.data?.data
  const pickupTrips = results[3]?.data?.data
  const dropTrips = results[4]?.data?.data
  const subSchools = results[5]?.data?.data

  const initialValues = {
    student_name: '',
    class_name: '',
    division: '',
    shift_id: '',
    seat_number: '',
    dob: '',
    regID: '',
    gender: '',
    student_status: '',
    parent_name: '',
    parent_mobile: '',
    country_code: '',
    parent_email: '',
    user_status: '',
    country: '',
    parent_gender: '',
    parent_dob: '',
    whatsapp: '',
    relation: '',
    zone: '',
    street: '',
    building_number: '',
    pickup_zone: '',
    pickup_street: '',
    pickup_building_number: '',
    pickup_trip_id: '',
    drop_zone: '',
    drop_street: '',
    drop_building_number: '',
    drop_trip_id: '',
    sub_school_id: '',
  }

  const relationOptions = [
    {key: 'Father', value: 'father'},
    {key: 'Mother', value: 'mother'},
    {key: 'Guardian', value: 'guardian'},
    {key: 'Other', value: 'other'},
  ]

  const submitHandler = (values, {setSubmitting}) => {
    const toastId = toast.loading('Submitting...')
    setSubmitting(true)
    const payload = {...values}
    payload.parent_mobile = payload.parent_mobile.replace('+' + payload.country_code, '')

    const dateFields = ['dob', 'parent_dob']

    dateFields.forEach((field) => {
      if (payload[field] === '') {
        console.log(field)
        payload[field] = null
      }
    })

    createStudent(payload)
      .then(() => {
        toast.success('Student created successfully!', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => handleApiError(err, toastId))
      .finally(() => setSubmitting(false))
  }

  const validationSchema = Yup.object({
    student_name: Yup.string().required('Required'),
    class_name: Yup.string().required('Required'),
    division: Yup.string().required('Required'),
    shift_id: Yup.string().required('Required'),
    seat_number: Yup.string().required('Required'),
    sub_school_id: Yup.string().required('Required'),
    regID: Yup.string().required('Required'),
    dob: Yup.date()
      .test('is-4-digit-year', 'Year must be a 4-digit number', (value) => {
        if (!value) return true
        const year = value.getFullYear()
        return year >= 1000 && year <= 9999
      })
      .nullable(),
    gender: Yup.string().required('Required'),
    student_status: Yup.string().required('Required'),
    parent_name: Yup.string(),
    parent_mobile: Yup.string()
      .trim()
      .required('Required')
      .test('parent_mobile', 'Enter a valid phone number', (value) => {
        if (value) {
          return isPossiblePhoneNumber(value)
        }
        return false
      }),
    country_code: Yup.string()
      .trim()
      .required('Country Code is required')
      .notOneOf([''], 'Country Code is Required'),
    relation: Yup.string(),
    parent_email: Yup.string().email('Invalid Email'),
    user_status: Yup.string().required('Required'),
    country: Yup.string(),
    zone: Yup.string().required('Required'),
    street: Yup.string().required('Required'),
    building_number: Yup.string().required('Required'),
    pickup_zone: Yup.string(),
    pickup_street: Yup.string(),
    pickup_building_number: Yup.string(),
    pickup_trip_id: Yup.string().required('Required'),
    drop_zone: Yup.string(),
    drop_street: Yup.string(),
    drop_building_number: Yup.string(),
    drop_trip_id: Yup.string().required('Required'),
  })

  const pickupTripOptions = pickupTrips?.map((trip) => ({
  ...trip,
  trip_label: `${trip.trip_name} (${trip.shift_name || 'No Shift'})`,
}))

const dropTripOptions = dropTrips?.map((trip) => ({
  ...trip,
  trip_label: `${trip.trip_name} (${trip.shift_name || 'No Shift'})`,
}))

  return (
    <div className="px-5 py-4">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid, values, setFieldValue}) => (
          <Form>
            <fieldset className="mb-4">
              <legend>Basic Details</legend>
              <Row>
                <Col md="4">
                  <FormikControl
                    control="input"
                    name="student_name"
                    label="Student Name"
                    placeholder="Student Name"
                    required
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control={'select-advanced'}
                    options={subSchools}
                    placeholder="Sub School"
                    label="Sub School"
                    name="sub_school_id"
                    optionLabel={'sub_school_name'}
                    optionValue={'sub_school_id'}
                    required
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control={'select-advanced'}
                    options={gradeList}
                    placeholder="Grade"
                    label="Grade"
                    name="class_name"
                    optionLabel={'class_name'}
                    optionValue={'class_name'}
                    required
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control={'select-advanced'}
                    options={divisionList}
                    placeholder="Division"
                    label="Division"
                    name="division"
                    optionLabel={'division_name'}
                    optionValue={'division_name'}
                    required
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control={'select-advanced'}
                    options={shiftList}
                    placeholder="Shift"
                    label="Shift"
                    name="shift_id"
                    optionLabel={'shift_name'}
                    optionValue={'shift_id'}
                    required
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="input"
                    name="seat_number"
                    label="Seat Number"
                    placeholder="Seat Number"
                    required
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="input"
                    name="regID"
                    label="Reg ID"
                    placeholder="Registration ID"
                    required
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="check"
                    type="radio"
                    name="gender"
                    label="Gender"
                    options={[
                      {key: 'Male', value: 'male'},
                      {key: 'Female', value: 'female'},
                    ]}
                    required
                  />
                </Col>
                <Col md="4">
                  <FormikControl control="input" name="dob" label="DOB" type="date" />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="check"
                    type="radio"
                    name="student_status"
                    label="Active Status"
                    required
                    options={[
                      {key: 'Active', value: '1'},
                      {key: 'Inactive', value: '0'},
                    ]}
                  />
                </Col>
              </Row>
            </fieldset>

            <fieldset className="mb-4">
              <legend>Parent Details</legend>
              <Row>
                <Col md="4">
                  <FormikControl
                    control="input"
                    name="parent_name"
                    label="Parent Name"
                    placeholder="Parent Name"
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="phone-input"
                    name="parent_mobile"
                    label="Parent Number"
                    placeholder="Parent Mobile"
                    required
                    onCountryChange={(value) => {
                      let code
                      if (value) {
                        code = getCountryCallingCode(value)
                      } else {
                        code = ''
                      }
                      setFieldValue('country_code', code)
                    }}
                  />
                </Col>

                <Col md="4">
                  <FormikControl
                    control="select-advanced"
                    name="relation"
                    label="Relation"
                    options={relationOptions}
                    optionLabel="key"
                    optionValue="value"
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="input"
                    name="parent_email"
                    type="email"
                    label="Parent email"
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="check"
                    type="radio"
                    name="user_status"
                    label="Parent Status"
                    options={[
                      {key: 'Active', value: '1'},
                      {key: 'Inactive', value: '0'},
                    ]}
                    required
                  />
                </Col>
                <Col md="4">
                  <CountrySelect name="country" label="Parent Country" />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="check"
                    type="radio"
                    name="parent_gender"
                    label="Parent Gender"
                    options={[
                      {key: 'Male', value: 'male'},
                      {key: 'Female', value: 'female'},
                    ]}
                  />
                </Col>

                <Col md="4">
                  <FormikControl control="input" name="parent_dob" label="Parent DOB" type="date" />
                </Col>
                <Col md="4">
                  <FormikControl control="input" name="whatsapp" label="Whatsapp" />
                </Col>
              </Row>
            </fieldset>

            <fieldset className="mb-4">
              <legend>Communication Address</legend>
              <Row>
                <Col md="4">
                  <FormikControl control="input" name="zone" label="Zone" required />
                </Col>
                <Col md="4">
                  <FormikControl control="input" name="street" label="Street" required />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="input"
                    name="building_number"
                    label="Building Number"
                    required
                  />
                </Col>
              </Row>
            </fieldset>

            <fieldset className="mb-4">
              <legend>Pickup Trip Details</legend>
              <Row>
                <Col md="4">
                  <FormikControl control="input" name="pickup_zone" label="Zone" />
                </Col>
                <Col md="4">
                  <FormikControl control="input" name="pickup_street" label="Street" />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="input"
                    name="pickup_building_number"
                    label="Building Number"
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="select-advanced"
                    name="pickup_trip_id"
                    label="Pick Up Trip"
                    options={pickupTripOptions}
                    optionLabel="trip_label"
                    optionValue="trip_id"
                    required
                  />
                </Col>
              </Row>
            </fieldset>

            <fieldset className="mb-4">
              <legend>Drop Trip Details</legend>
              <Row>
                <Col md="4">
                  <FormikControl control="input" name="drop_zone" label="Zone" />
                </Col>
                <Col md="4">
                  <FormikControl control="input" name="drop_street" label="Street" />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="input"
                    name="drop_building_number"
                    label="Building Number"
                  />
                </Col>
                <Col md="4">
                  <FormikControl
                    control="select-advanced"
                    name="drop_trip_id"
                    label="Drop Trip"
                    options={dropTripOptions}
                    optionLabel="trip_label"
                    optionValue="trip_id"
                    required
                  />
                </Col>
              </Row>
            </fieldset>

            {console.log(values)}
            <div className="text-center pt-4">
              <FormResetBtn onClick={resetForm} disabled={isSubmitting} className="me-3" />
              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default StudentCreationForm
